import * as React from 'react';

import * as style from './style.css';

interface IPageLayoutProps {
  children?: React.ReactNode;
}

export function PageLayout({ children }: IPageLayoutProps) {
  return (
    <div className={style['container']} data-testid="PageLayout">
      {children}
    </div>
  );
}
